module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-up.cf2ca80f.svg";